module.exports = __webpack_public_path__ + "img/kitkitlogo_eng.1028d410.png";